import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SidebarService {


  SidebarSize = 'max';
  currentSidebarSize = signal(this.SidebarSize);
  sidebarSizeChange: Subject<string> = new Subject<string>();


  sidebarSizeSave(size: string) {
    this.currentSidebarSize.set(size);
  }

  toggleSidebarSize(size: string) {
    if (size === 'max') {
      this.currentSidebarSize.set('min');
    } else {
      this.currentSidebarSize.set('max');
    }
    return true;
  }
}

